export const DownTimeReasonsLogPage = () => {
    return <>DownTimeReasonsLogPage</>
}
